import { NativeSelect } from '@mui/material';
import { IFloatingFilterParams } from 'ag-grid-community';
import { forwardRef, useImperativeHandle, memo, useRef, useState } from 'react';

export const PalletTypeFloatingFilterComponent = memo(
    forwardRef((props: IFloatingFilterParams, ref) => {
        const [, setCurrentValue] = useState(null as number | null);
        const inputRef = useRef<HTMLInputElement>(null);
        // expose AG Grid Filter Lifecycle callbacks
        useImperativeHandle(ref, () => {
            return {
                onParentModelChanged(parentModel) {
                    // When the filter is empty we will receive a null value here
                    if (inputRef != null && inputRef.current != null) {
                        if (!parentModel) {
                            inputRef.current.value = '';
                            setCurrentValue(null);
                        } else {
                            inputRef.current.value = parentModel.filter + '';
                            setCurrentValue(parentModel.filter);
                        }
                    }
                }
            };
        });
        const onInputBoxChanged = value => {
            if (value != '0' && value != '1') {
                // clear the filter
                props.parentFilterInstance(instance => {
                    instance.onFloatingFilterChanged(null, null);
                });
                return;
            }

            setCurrentValue(value);

            props.parentFilterInstance(instance => {
                instance.onFloatingFilterChanged('equals', value);
            });
        };

        return (
            <>
                <NativeSelect onChange={input => onInputBoxChanged(input.target.value)}>
                    <option value={undefined}>&nbsp;</option>
                    <option value={0}>EUR</option>
                    <option value={1}>SPA</option>
                </NativeSelect>
            </>
        );
    })
);
